import React from "react";
import { MainBlockBannerModel } from "@admin/domain/uniquePages/models/MainPageModel";
import { Language } from "@admin/domain/languages/helpers";
import Input from "@admin/components/Input";
import MultiLanguages from "@admin/components/MultiLanguage";
import JoditEditor from "@admin/components/JoditEditor";

type Props = {
    banner: MainBlockBannerModel;
    index: number;
};

export default function BannerFields({ banner, index }: Props) {
    return (
        <div className="card-text mb-3">
            <MultiLanguages
                languageElement={(language: Language) => (
                    <Input
                        label="Заголовок"
                        name={`content[main_block__banners][${index}][title][${language}]`}
                        defaultValue={banner.title[language]}
                    />
                )}
            />

            <MultiLanguages
                languageElement={(language: Language) => (
                    <JoditEditor
                        label="Текст под заголовком"
                        name={`content[main_block__banners][${index}][description][${language}]`}
                        initHtml={banner.description[language] || ``}
                    />
                )}
            />

            <MultiLanguages
                languageElement={(language: Language) => (
                    <Input
                        label="Текст кнопки"
                        name={`content[main_block__banners][${index}][button_text][${language}]`}
                        defaultValue={banner.button_text[language]}
                    />
                )}
            />

            <Input label="Ссылка" name={`content[main_block__banners][${index}][url]`} defaultValue={banner.url} />

            <MultiLanguages
                languageElement={(language: Language) => (
                    <Input
                        label="Тэг"
                        name={`content[main_block__banners][${index}][tag][${language}]`}
                        defaultValue={banner.tag[language]}
                    />
                )}
            />

            {banner.with_mobile_app_file && (
                <>
                    <MultiLanguages
                        languageElement={(language: Language) => (
                            <Input
                                label="Заголовок для МП"
                                name={`content[main_block__banners][${index}][mobile_app_title][${language}]`}
                                defaultValue={banner.mobile_app_title[language]}
                            />
                        )}
                    />

                    <MultiLanguages
                        languageElement={(language: Language) => (
                            <Input
                                label="Описание для МП"
                                name={`content[main_block__banners][${index}][mobile_app_description][${language}]`}
                                defaultValue={banner.mobile_app_description[language]}
                            />
                        )}
                    />

                    <Input
                        label="Ссылка для МП"
                        name={`content[main_block__banners][${index}][mobile_app_url]`}
                        defaultValue={banner.mobile_app_url || ``}
                    />
                </>
            )}
        </div>
    );
}
